export default __webpack_public_path__ + "static/media/198.ecc2579b.gif";